import React from 'react';
import EventsList from './EventsList.jsx';
import {getFormattedDate} from '../calendarHelper.js';
import FutureEvents from './FutureEvents.jsx';

export default class EventsDisplay extends React.PureComponent {
  render() {
    const {events, eventDate, futureEventsList, showFuture, lastEvent, singleTeamView} = this.props;
    let keys = Object.keys(futureEventsList).slice(0, 5);
    keys.sort((a, b) => {
      let dateA = new Date(a);
      let dateB = new Date(b);
      return dateA - dateB;
    })

    let t = []
    if (keys) {
      keys.forEach(key => {
        t.push(futureEventsList[key]);
      })
    }

    let lastKey = Object.keys(lastEvent).sort();
    let lastTime = [];
    if (lastKey) {
      lastKey.forEach(key => {
        lastTime.push(lastEvent[key]);
      });
    }

    let timeKeys = [];
    if (events) {
      timeKeys = Object.keys(events).sort();
    }

    timeKeys.sort((a, b) => {
      let time1 = ' ' + a.slice(0, a.length - 2) + ' ' + a.slice(a.length - 2, a.length);
      let time2 = ' ' + b.slice(0, b.length - 2) + ' ' + b.slice(b.length - 2, b.length);
      return new Date('1970/01/01' + time1) - new Date('1970/01/01' + time2);
    });

    return (
      <div className="eventDisplay px-3 ">
        {getFormattedDate(eventDate) ?
          <header className="SectionHeader text-start p-3">
            <i className="fa-regular fa-calendar-check"></i>
            <span className="EventDate">{getFormattedDate(eventDate)}</span>
          </header>
          :
          null
          // <header className="SectionHeader text-start p-3">
          //   <i className="fa-regular fa-calendar-check"></i>
          //   <span className="EventDate">{getFormattedDate(...lastKey || currentDate)}</span>
          // </header>
        }
        <div className={`SectionBodyWrapper`}>
          <div className="row">
            <div className="col">
              {
                !!events ? timeKeys.map((time, idx) => (
                    <EventsList
                      singleTeamView={singleTeamView}
                      eventDate={eventDate}
                      eventsAtTime={events[time]}
                      time={time}
                      key={`event-${idx}`}
                    />
                  )) :
                  (<div className="noEvents">
                    <p className={'mt-2'}>No Events Today</p>
                  </div>)
              }
            </div>
          </div>
        </div>
        <section className='SectionBodyWrapper'>
          {
            // we check to see if there is no future event in the t array and showFuture is true meaning user has not click on anything yet we show past event
            t.length < 1 && showFuture && timeKeys.length < 1 ? lastTime.map((eventsByTime, index) => (
              <FutureEvents key={index} singleTeamView={singleTeamView} eventsByTime={eventsByTime} eventDate={lastKey[index]} lastEvent={true} />
            )) : null
          }
          {
            showFuture ?
              t.map((eventsByTime, index) => (
                <FutureEvents key={index} singleTeamView={singleTeamView} eventsByTime={eventsByTime} eventDate={keys[index]} lastEvent={false} />
              ))
              :
              null
          }
        </section>
      </div>
    );
  }
}
